module.exports = __webpack_public_path__ + "static/Rathausplatz1-8247ad94bd92d7cb3d303e8486e02726.JPG";